module.exports = __webpack_public_path__ + "static/White Logo-6d9c0e55c3e86090c8144419f8ddf44c.png";